export default {
  AFN: 0,
  ALL: 0,
  DZD: 2,
  ARS: 2,
  AMD: 0,
  AUD: 2,
  AZN: 2,
  BDT: 2,
  BYN: 2,
  BZD: 2,
  BOB: 2,
  BAM: 2,
  BWP: 2,
  BRL: 2,
  GBP: 2,
  BND: 2,
  BGN: 2,
  BIF: 0,
  KHR: 2,
  CAD: 2,
  CVE: 2,
  XAF: 0,
  CLP: 0,
  CNY: 2,
  COP: 0,
  KMF: 0,
  CDF: 2,
  CRC: 0,
  HRK: 2,
  CZK: 2,
  DKK: 2,
  DJF: 0,
  DOP: 2,
  EGP: 2,
  ETB: 2,
  EUR: 2,
  GEL: 2,
  GTQ: 2,
  GNF: 0,
  HNL: 2,
  HKD: 2,
  HUF: 0,
  ISK: 0,
  INR: 2,
  IDR: 0,
  ILS: 2,
  JMD: 2,
  JPY: 0,
  KZT: 2,
  KES: 2,
  LBP: 0,
  MOP: 2,
  MKD: 2,
  MGA: 0,
  MYR: 2,
  MUR: 0,
  MXN: 2,
  MDL: 2,
  MAD: 2,
  MZN: 2,
  MMK: 0,
  NAD: 2,
  NPR: 2,
  TWD: 2,
  NZD: 2,
  NIO: 2,
  NGN: 2,
  NOK: 2,
  PKR: 0,
  PAB: 2,
  PYG: 0,
  PEN: 2,
  PHP: 2,
  PLN: 2,
  QAR: 2,
  RON: 2,
  RUB: 2,
  RWF: 0,
  SAR: 2,
  RSD: 0,
  SGD: 2,
  SOS: 0,
  ZAR: 2,
  KRW: 0,
  LKR: 2,
  SEK: 2,
  CHF: 2,
  TZS: 0,
  THB: 2,
  TOP: 2,
  TTD: 2,
  TRY: 2,
  USD: 2,
  UGX: 0,
  UAH: 2,
  AED: 2,
  UYU: 2,
  UZS: 0,
  VND: 0,
  XOF: 0,
  YER: 0,
  ANG: 2,
  AOA: 2,
  AWG: 2,
  BBD: 2,
  BMD: 2,
  BSD: 2,
  FJD: 2,
  FKP: 2,
  GIP: 2,
  GMD: 2,
  GYD: 2,
  HTG: 2,
  KGS: 2,
  KYD: 2,
  LAK: 2,
  LRD: 2,
  LSL: 2,
  MNT: 2,
  MRO: 2,
  MVR: 2,
  MWK: 2,
  PGK: 2,
  SBD: 2,
  SCR: 2,
  SHP: 2,
  SLE: 2,
  SLL: 2,
  SRD: 2,
  STD: 2,
  SZL: 2,
  TJS: 2,
  VUV: 0,
  WST: 2,
  XCD: 2,
  XPF: 0,
  ZMW: 2,
} as const;
